:host {
    background-color: transparent;
    display: block;
    padding-bottom: 40px;
    padding-top: 20px;
    position: relative;

    c-form-controls {
        max-width: 100%;
    }

    .controls {
        margin: 1rem 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        c-link {
            align-self: flex-start;
        }

        & > * {
            flex-grow: 1;
        }
    }

    .text-error {
        padding-top: 10px;
        color: #a7003b;
        white-space: pre;
        font-size: 16px;
    }

    c-trust-level {
        display: block;
        color: $color-bund-blue;
        position: absolute;
        top: 40px;
        right: 40px;
    }
}
